import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-mobile',
  templateUrl: './search-mobile.component.html',
  styleUrls: ['./search-mobile.component.scss']
})
export class SearchMobileComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();
  constructor() { }

  ngOnInit(): void {
  }
}
